import React, { useState } from 'react';
import Confetti from 'react-confetti'; // Import the Confetti component
import questions from './questions';
import './QuizPage.css';

function QuizPage({ userInfo }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [score, setScore] = useState(0);
  const [showResults, setShowResults] = useState(false);
  const [attemptedQuestions, setAttemptedQuestions] = useState([]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const handleNextQuestion = () => {
    if (selectedOption === questions[currentQuestion].correctAnswer) {
      setScore(score + 1);
    }
    setAttemptedQuestions([...attemptedQuestions, currentQuestion]);
    setSelectedOption(null);
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setShowResults(true);
    }
  };

  const handleBackQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleSkipQuestion = () => {
    setAttemptedQuestions([...attemptedQuestions, currentQuestion]);
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setShowResults(true);
    }
  };

  return (
    <div className="quiz-page">
      {showResults ? (
        <div className="results">
          <Confetti />  {/* Confetti animation */}
          <h2>Congratulations, {userInfo.name}!</h2>
          <h3>Your Score: {score} / {questions.length}</h3>
          <div className="result-details">
            <p><strong>Name:</strong> {userInfo.name}</p>
            <p><strong>Age:</strong> {userInfo.age}</p>
            <p><strong>Gender:</strong> {userInfo.gender}</p>
            <p><strong>Total Questions:</strong> {questions.length}</p>
            <p><strong>Attempted:</strong> {attemptedQuestions.length}</p>
            <p><strong>Correct:</strong> {score}</p>
            <p><strong>Skipped:</strong> {questions.length - attemptedQuestions.length}</p>
          </div>
        </div>
      ) : (
        <>
          <h1>{questions[currentQuestion].question}</h1>
          <div className="options">
            {questions[currentQuestion].options.map((option) => (
              <div
                key={option}
                className={`option ${selectedOption === option ? 'selected' : ''}`}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </div>
            ))}
          </div>
          <div className="quiz-controls">
            <button className="back-btn" onClick={handleBackQuestion} disabled={currentQuestion === 0}>
              Back
            </button>
            <button className="skip-btn" onClick={handleSkipQuestion}>
              Skip
            </button>
            <button className="next-btn" onClick={handleNextQuestion} disabled={selectedOption === null}>
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default QuizPage;
